export default __webpack_public_path__ + "static/media/python.6067726f.png";